var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartmentNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.934,
    height: 65.934,
    viewBox: "0 0 65.934 65.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3181",
    "data-name": "Group 3181",
    transform: "translate(-1203 -286.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3181-2",
    "data-name": "Group 3181",
    transform: "translate(633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "department",
    transform: "translate(570 286.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M32.967,0A32.967,32.967,0,1,1,0,32.967,32.967,32.967,0,0,1,32.967,0Z",
    fill: "#009bad"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3184",
    "data-name": "Group 3184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M184.218,244.18v-2.329a1.109,1.109,0,0,1,1.109-1.109h12.2v3.438a5.594,5.594,0,0,1,2.218,0v-3.438H212.5a1.112,1.112,0,0,1,1.109,1.109v2.329a5.594,5.594,0,0,1,2.218,0v-2.329a3.334,3.334,0,0,0-3.327-3.327H199.744V235.2h-2.218v3.327h-12.2A3.33,3.33,0,0,0,182,241.851v2.329a5.594,5.594,0,0,1,2.218,0Z",
    transform: "translate(1038.365 74.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M292.624,426.66a5.5,5.5,0,0,1-6.338,0,4.441,4.441,0,0,0-3.482,4.33v2.218a1.109,1.109,0,0,0,1.109,1.109H295a1.112,1.112,0,0,0,1.109-1.109V430.99a4.446,4.446,0,0,0-3.488-4.33Z",
    transform: "translate(947.542 -97.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M449.822,426.065a5.5,5.5,0,0,1-6.288-.183,4.441,4.441,0,0,0-3.931,4.408v2.218a1.109,1.109,0,0,0,1.109,1.109H451.8a1.112,1.112,0,0,0,1.109-1.109V430.29a4.449,4.449,0,0,0-3.088-4.225Z",
    transform: "translate(806.269 -97.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M135.824,426.66a5.5,5.5,0,0,1-6.338,0A4.441,4.441,0,0,0,126,430.99v2.218a1.109,1.109,0,0,0,1.109,1.109H138.2a1.112,1.112,0,0,0,1.109-1.109V430.99a4.445,4.445,0,0,0-3.488-4.33Z",
    transform: "translate(1088.816 -97.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M323.05,350.525a3.327,3.327,0,1,1-3.327-3.327,3.327,3.327,0,0,1,3.327,3.327",
    transform: "translate(917.276 -26.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M283.909,143.122H295a1.112,1.112,0,0,0,1.109-1.109V139.8a4.445,4.445,0,0,0-3.488-4.33,5.505,5.505,0,0,1-6.338,0,4.44,4.44,0,0,0-3.482,4.33v2.218a1.109,1.109,0,0,0,1.109,1.109Z",
    transform: "translate(947.546 164.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M323.05,59.327A3.327,3.327,0,1,1,319.723,56a3.327,3.327,0,0,1,3.327,3.327",
    transform: "translate(917.276 236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M485.454,350.525a3.327,3.327,0,1,1-3.327-3.327,3.327,3.327,0,0,1,3.327,3.327",
    transform: "translate(770.953 -26.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M166.254,350.525a3.327,3.327,0,1,1-3.327-3.327,3.327,3.327,0,0,1,3.327,3.327",
    transform: "translate(1058.547 -26.365)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentNew);
export default __webpack_public_path__ + "static/media/departmentNew.bf4b6789024ebec392b3eb13dc912db2.svg";
export { ForwardRef as ReactComponent };